import posthog from "posthog-js";

import { redactAnalyticsData, redactAnalyticsText, redactAnalyticsUrl } from "@/shared/analytics/pageview-redaction";

const posthogToken = process.env.NEXT_PUBLIC_POSTHOG_TOKEN;

if (posthogToken) {
  posthog.init(posthogToken, {
    api_host: "/ingest",
    capture_exceptions: true,
    capture_pageview: "history_change",
    capture_pageleave: true,
    // Replay URLs are masked before compression; snapshot strings must remain byte-for-byte intact.
    before_send: (event) => (event?.event === "$snapshot" ? event : redactAnalyticsData(event)),
    disable_capture_url_hashes: true,
    enable_recording_console_log: false,
    defaults: "2026-01-30",
    debug: process.env.NODE_ENV === "development",
    loaded: (client) => client.startSessionRecording(true),
    session_recording: {
      maskAllInputs: true,
      recordHeaders: false,
      recordBody: false,
      maskCapturedNetworkRequestFn: (request) => {
        const sanitized = redactAnalyticsData(request);
        delete sanitized.requestHeaders;
        delete sanitized.requestBody;
        delete sanitized.responseHeaders;
        delete sanitized.responseBody;
        return { ...sanitized, name: redactAnalyticsUrl(request.name) };
      },
      maskAttributeFn: (_name, value) => redactAnalyticsText(value),
    },
    ui_host: process.env.NEXT_PUBLIC_POSTHOG_UI_HOST ?? "https://us.posthog.com",
  });
} else if (typeof window !== "undefined") {
  console.warn("[posthog] NEXT_PUBLIC_POSTHOG_TOKEN is not set — analytics disabled");
}
